var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row swiper-1row d-md-none mb-1 mt-2 text-center" },
      [
        _c("h2", { staticClass: "mx-1" }, [
          _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "ob1-carrousel equipment-band-swiper-container" },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(
                  _vm.equipmentsBand,
                  function (equipmentBand, equipmentBandIndex) {
                    return _c(
                      "div",
                      { key: equipmentBandIndex, staticClass: "swiper-slide" },
                      [
                        equipmentBand
                          ? _c(
                              "a",
                              {
                                staticClass: "equipment-band",
                                attrs: {
                                  href: equipmentBand.url,
                                  "data-oevent-category":
                                    equipmentBand.tms.tagZone,
                                  "data-oevent-action":
                                    equipmentBand.tms.tagName,
                                  "data-oevent-label": equipmentBand.url,
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "forward-first-card",
                                  class: equipmentBand.forwardFirst
                                    ? "bg-greige"
                                    : "bg-white",
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "equipment-band-image-swiper",
                                  attrs: {
                                    src: equipmentBand.image.src,
                                    alt: equipmentBand.image.alt,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "lead p-0 m-0 pt-2 fw-bold title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(equipmentBand.title)
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }
                ),
                0
              ),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-none d-md-block mb-1 mt-2" },
      [
        _c("h2", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _vm._l(_vm.numberOfRows(4), function (y) {
          return _c(
            "div",
            { key: y, staticClass: "row text-center" },
            _vm._l(4, function (x) {
              return _c("div", { key: x, staticClass: "col-3" }, [
                _vm.equipmentsBand[_vm.index(x, y, 4)]
                  ? _c(
                      "a",
                      {
                        staticClass: "equipment-band",
                        attrs: {
                          href: _vm.equipmentsBand[_vm.index(x, y, 4)].url,
                          "data-oevent-category":
                            _vm.equipmentsBand[_vm.index(x, y, 4)].tms.tagZone,
                          "data-oevent-action":
                            _vm.equipmentsBand[_vm.index(x, y, 4)].tms.tagName,
                          "data-oevent-label":
                            _vm.equipmentsBand[_vm.index(x, y, 4)].url,
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "forward-first-card",
                          class: _vm.equipmentsBand[_vm.index(x, y, 4)]
                            .forwardFirst
                            ? "bg-greige"
                            : "bg-white",
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "equipment-band-image",
                          attrs: {
                            src: _vm.equipmentsBand[_vm.index(x, y, 4)].image
                              .src,
                            alt: _vm.equipmentsBand[_vm.index(x, y, 4)].image
                              .alt,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "h3",
                          { staticClass: "lead p-0 m-0 pt-2 fw-bold title" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.equipmentsBand[_vm.index(x, y, 4)].title
                                )
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            }),
            0
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex justify-content-center mb-1 mb-md-2" },
      [
        _c("ob1-liens", {
          attrs: {
            text: _vm.labelButton,
            href: _vm.urlButton,
            "with-arrow": "",
            "data-oevent-category": "marchand_eqpt",
            "data-oevent-action": "voir-tous-les-mobiles",
            "data-oevent-label": _vm.urlButton,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }